
import { z } from 'zod';
import { BotType, BotStatus, ColorScheme, ExchangePlatform } from './trader';

export const deployBotSchema = z.object({
  name: z.string().min(3, { message: 'Bot name must be at least 3 characters' }).max(50),
  description: z.string().min(10, { message: 'Description must be at least 10 characters' }).max(500),
  exchanges: z.array(z.string()).min(1, { message: 'Select at least one exchange' }),
  colorScheme: z.string().optional(),
});

export type DeployBotFormValues = z.infer<typeof deployBotSchema>;
